import React from "react"
import { Navigate } from "react-router-dom"

// Profile
import UserProfile from "../pages/Authentication/UserProfile"

// Authentication related pages
import Logout from "../pages/Authentication/Logout"

// Other public pages
import ReleaseNote from "../pages/Public/ReleaseNote"
import DisturbanceNotice from "../pages/Public/DisturbanceNotice"

// LANDING PAGE
import LandingPage from "pages/LandingPage/LandingPage"

// CLIENTS
import Clients from "pages/Clients/Clients"

// MONITORING
import AlarmMonitoring from "pages/Monitoring/AlarmMonitoring/AlarmMonitoring"
import OfflineVideoMonitoring from "pages/Monitoring/OfflineVideos/OfflineVideos"

// REPORTING
import Reporting from "pages/Reporting/reporting"

// SERVICES CHARTS
import GeneralViewChart from "pages/Services/AtHome/GeneralViewChart"

//SUVANTO SERVICES
import GroupCall from "pages/Video/GroupCall/GroupCall"
import GroupCallTest from "pages/Video/GroupCall/GroupCallTest"

// ADMIN TOOLS
import PindoraConfigs from "pages/Developer/Devices/Pindoras/PindoraConfigs"
import GatewayConfigs from "pages/Developer/Devices/Gateways/GatewayConfigs"
import TrackerConfigs from "pages/Developer/Devices/Trackers/TrackerConfigs"
import VideoDevices from "pages/Developer/Devices/VideoDevices/VideoDevices"
import DoseConfigs from "pages/Developer/Devices/Doses/DoseConfigs"
import OrderManagement from "pages/Sales/OrderManagement"
import CarephoneConfigs from "pages/Developer/Devices/Carephones/CarephoneConfigs"
import MeasureDeviceConfigs from "pages/Developer/Devices/MeasureDevices/MeasureDeviceConfigs"
import SystemLogs from "pages/Developer/Logs/SystemLogs"
import ReleaseNotesManagement from "pages/Developer/Messaging/ReleaseNotesManagement"
import DisturbanceNoticesManagement from "pages/Developer/Messaging/DisturbanceNoticesManagement"
import EmailReleasesPage from "pages/Developer/Messaging/EmailReleases/email-releases"
import SMSMessaging from "pages/Developer/Messaging/SMSMessaging/SMSMessaging"
import ServiceMonitoring from "pages/Sales/ServiceMonitoring"
import VideoRooms from "pages/Developer/Devices/VideoRooms/VideoRooms"
import AdminUsersManagement from "pages/Developer/Users/AdminUsersManagement"
//import AdminUsersManagement2 from "pages/Developer/admin-users2/admin-users"
import ClientsManagementTable from "pages/Developer/Clients/ClientsManagementTable"

import KeycloakUsers from "pages/Developer/Users/KeycloakUsers"

import VideoContentEvents from "pages/Video/VideoContent/VideoContentEvents"
import GroupsManagement from "pages/Developer/Groups/GroupsManagement"
import QuickGuideManagement from "pages/Developer/Messaging/QuickGuideManagement"

import SmsLogs from "pages/Developer/Logs/SmsLogs"
import GatewayLogs from "pages/Developer/Logs/GatewayLogs"
import AuditLogs from "pages/Developer/Logs/AuditLogs"

import Appointments from "pages/Appointments/Appointments"

import VideoGroupMessage from "pages/Video/VideoGroupMessage/VideoGroupMessage"
import VideoAppSettings from "pages/Video/VideoAppSettings/VideoAppSettings"

import SupportTicketsReport from "pages/Developer/Misc/SupportTicketsReport"
import Instructions from "pages/Developer/Misc/Instructions"
import OrganizationUserManagement from "pages/Admin/OrganizationUsers/OrganizationUserManagement"

import AppUserManagement from "pages/Developer/AppUsers/AppUserManagement"
import KeycloakTools from "pages/Developer/Misc/KeycloakTools"
import ReturnsManagement from "pages/Sales/Returns/ReturnsManagement"

const authProtectedRoutes = [
  // LANDING PAGE
  { path: "/main", component: <LandingPage /> },

  // CLIENT MANAGEMENT
  // prettier-ignore
  // eslint-disable-next-line react/display-name
  { path: "/clients", exact: true, component: <Navigate to="/clients/select" replace/> },
  // prettier-ignore
  { path: "/clients/:clientId", component: <Clients/> },

  // MONITORING
  {
    path: "/monitoring/alarms",
    component: <AlarmMonitoring />,
    roles: [],
    permission: "alarm_monitoring",
  },
  {
    path: "/monitoring/offline-videos",
    component: <OfflineVideoMonitoring />,
    roles: [],
    permission: "offline_video_monitoring",
  },

  // PROFILE
  { path: "/profile", component: <UserProfile /> },

  // REPORTING PAGES
  {
    path: "/reporting",
    component: <Reporting />,
    roles: [
      "system_admin",
      "salesperson",
      "order_manager",
      "organisation_admin",
    ],
  },

  // SALES PAGES
  {
    path: "/sales/service-monitoring",
    component: <ServiceMonitoring />,
    roles: ["system_admin", "salesperson", "order_manager"],
  },

  // SERVICES PAGES
  {
    path: "/group-call",
    component: <GroupCall />,
    roles: [
      "system_admin",
      "organisation_admin",
      "organisation_user",
      "salesperson",
    ],
  },
  {
    path: "/group-call-test",
    component: <GroupCallTest />,
    roles: [
      "system_admin",
    ],
  },
  {
    path: "/at-home-chart-full",
    component: <GeneralViewChart />,
  },

  // ADMIN TOOLS
  // Add roles or permissions for access control
  {
    path: "/config/admins",
    component: <AdminUsersManagement />,
    roles: ["system_admin"],
  },
  {
    path: "/config/user-accounts",
    component: <KeycloakUsers />,
    roles: ["system_admin"],
  },
  {
    path: "/config/app-users",
    component: <AppUserManagement />,
    roles: ["system_admin", "organisation_admin"],
  },
  /*{
    path: "/admin/user-management",
    component: <UserManagement />,
    permission: "admin_management",
  },*/
  {
    path: "/admin/user-management",
    component: <OrganizationUserManagement />,
    permission: "admin_management",
  },
  {
    path: "/instructions",
    component: <Instructions />,
    permission: "instructions",
  },
  // TEST START
  /*{
    path: "/config/admins2",
    component: <AdminUsersManagement2 />,
    roles: ["system_admin"],
  },*/
  // TEST END
  {
    path: "/config/clients",
    component: <ClientsManagementTable />,
    roles: ["system_admin"],
  },
  {
    path: "/config/groups",
    component: <GroupsManagement />,
    roles: ["system_admin"],
  },
  {
    path: "/config/gateways",
    component: <GatewayConfigs />,
    roles: ["system_admin"],
  },
  {
    path: "/config/pindoras",
    component: <PindoraConfigs />,
    roles: ["system_admin"],
  },
  {
    path: "/config/trackers",
    component: <TrackerConfigs />,
    roles: ["system_admin"],
  },
  {
    path: "/config/video-devices",
    component: <VideoDevices />,
    roles: ["system_admin"],
  },
  {
    path: "/config/video-numbers",
    component: <VideoRooms />,
    roles: ["system_admin"],
  },
  {
    path: "/config/doses",
    component: <DoseConfigs />,
    roles: ["system_admin"],
  },
  {
    path: "/config/carephones",
    component: <CarephoneConfigs />,
    roles: ["system_admin"],
  },
  {
    path: "/config/measuringdevices",
    component: <MeasureDeviceConfigs />,
    roles: ["system_admin"],
  },
  {
    path: "/config/video-content",
    component: <VideoContentEvents />,
    permission: "video_system",
  },
  {
    path: "/config/keycloak-tools",
    component: <KeycloakTools />,
    roles: ["system_admin"],
  },
  {
    path: "/messaging/quick-guides",
    component: <QuickGuideManagement />,
    roles: ["system_admin"],
  },
  {
    path: "/sales/orders",
    component: <OrderManagement />,
    roles: ["system_admin", "salesperson", "order_manager"],
  },
  {
    path: "/sales/returns",
    component: <ReturnsManagement />,
    roles: ["system_admin", "order_manager"],
  },
  {
    path: "/messaging/release-notes",
    component: <ReleaseNotesManagement />,
    //roles: ["system_admin"],
    realm_role: "administrator_bulletins",
  },
  {
    path: "/messaging/disturbance-notices",
    component: <DisturbanceNoticesManagement />,
    //roles: ["system_admin"],
    realm_role: "administrator_bulletins",
  },
  {
    path: "/messaging/email-releases",
    component: <EmailReleasesPage />,
    //roles: ["system_admin"],
    realm_role: "administrator_bulletins",
  },
  {
    path: "/messaging/sms",
    component: <SMSMessaging />,
    roles: ["system_admin"],
  },
  {
    path: "/logs/system",
    component: <SystemLogs />,
    roles: ["system_admin"],
  },
  {
    path: "/logs/sms",
    component: <SmsLogs />,
    roles: ["system_admin"],
  },
  {
    path: "/logs/gateway",
    component: <GatewayLogs />,
    roles: ["system_admin"],
  },
  {
    path: "/logs/audit-logs",
    component: <AuditLogs />,
    roles: ["system_admin"],
  },
  {
    path: "/reporting/support-tickets",
    component: <SupportTicketsReport />,
    roles: ["system_admin"],
  },
  {
    path: "/appointments",
    component: <Appointments />,
    permission: "appointments",
  },
  {
    path: "/video/group-messages",
    component: <VideoGroupMessage />,
    permission: "groupMessages",
  },
  {
    path: "/video/app-settings",
    component: <VideoAppSettings />,
    permission: "video_app_settings",
  },

  // this route should be at the end of all other routes
  // prettier-ignore
  // eslint-disable-next-line react/display-name
  { path: "*", exact: true, component: <Navigate to="/main" replace/> },
]

const publicRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/release-note/:id", component: <ReleaseNote /> },
  { path: "/disturbance-notice/:id", component: <DisturbanceNotice /> },
]

export { publicRoutes, authProtectedRoutes }
